import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";

import TotalUserCount from "./TotalUserCount";
import TotalSurveyCompleted from "./TotalSurveyCompleted";
import TotalPublisherPayout from "./TotalPublisherPayout";
import DashboardFilter from "./DashboardFilter";
import DailyRevenueChart from "./DailyRevenueChart";
import DailyActiveUserChart from "./DailyActiveUserChart";
import TotalSurveryData from "./TotalSurveryAttempted";
import AverageRevenuePerUser from "./AverageRevenuePerUser";
import TotalConversionRate from "./TotalConversionRate";
import TotalSurveryAttempted from "./TotalSurveryAttempted";

export default function Dashboard() {
  const [open, setOpen] = useState(false);
  const [dateRangeLabel, setDateRangeLabel] = useState("Last 7 Days Data");

  return (
    <>
      <Helmet>
        <title> Real Opinion Publisher | Dashboard </title>
      </Helmet>
      <AppbarUI />
      <DrawerUI />
      <Stack sx={{ marginTop: 2 }}>
        <BodyWapperUI>
          <Grid
            container
            sx={{
              paddingBottom: 2,
              borderBottom: "1px solid rgba(217, 217, 217, 1)",
              alignItems: "center",
              justifyContent: {
                xs: "flex-start",
                sm: "space-between",
              },
            }}
          >
            <Box display={"flex"} flexDirection={"column"} gap={1}>
              <Typography
                sx={{
                  fontSize: "12px",
                }}
                variant="p"
              >
                Duration
              </Typography>

              <Typography
                sx={{
                  border: "1px solid rgba(217, 217, 217, 1)",
                  paddingInline: "20px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "40px",
                }}
                variant="p"
              >
                {dateRangeLabel}
              </Typography>
            </Box>
            <Box
              maxWidth={{
                xs: "100%",
                sm: "auto",
              }}
            >
              <DashboardFilter
                onDateRangeChange={(label) => setDateRangeLabel(label)}
              />
            </Box>
          </Grid>

          <Grid
            container
            spacing={2} // combines row and column spacing
            sx={{ mt: 4 }}
          >
            <Grid item xs={6} md={4}>
           
              <TotalUserCount />
            </Grid>
            <Grid item xs={6} md={4}>
              <TotalSurveyCompleted />
            </Grid>
            <Grid item xs={6} md={4}>
              <TotalSurveryAttempted />
            </Grid>
            <Grid item xs={6} md={4}>
              <TotalConversionRate />
            </Grid>
            <Grid item xs={6} md={4}>
              <TotalPublisherPayout />
            </Grid>
            <Grid item xs={6} md={4}>
              <AverageRevenuePerUser />
            </Grid>
          </Grid>

          {/* <Grid
            container
            columnSpacing={1}
            rowSpacing={1}
            sx={{ mt: 8, pb: 8 }}
          >
            <Grid item xs={12}>
              <DailyRevenueChart />
            </Grid>
          </Grid> */}

          {/* <Grid
            container
            columnSpacing={1}
            rowSpacing={1}
            sx={{ mt: 8, pb: 8 }}
          >
            <Grid item xs={12}>
              <DailyActiveUserChart />
            </Grid>
          </Grid> */}

          <Grid
            container
            columnSpacing={1}
            rowSpacing={1}
            sx={{ mt: 8, pb: 8 }}
          >
            <Grid item xs={12}>
              <DailyRevenueChart />
            </Grid>
            <Grid item xs={12}>
              <DailyActiveUserChart />
            </Grid>
          </Grid>
        </BodyWapperUI>
      </Stack>
    </>
  );
}
